// extracted by mini-css-extract-plugin
export default {"icon":"ModelDialog_icon__qkNXs","description":"ModelDialog_description__yp3hV","content":"ModelDialog_content__4qQyJ","modal":"ModelDialog_modal__H3QCR"};